const getItineraryPriceBeforeUpdate = ({ updatedItineraries, tripSegmentId }) => {
  if (tripSegmentId === null || !updatedItineraries || updatedItineraries.length === 0) {
    return null;
  }
  const updatedItinerary =
    updatedItineraries.find((br) => br.tripSegmentId === tripSegmentId) || {};

  if (updatedItinerary === null) {
    return null;
  }
  return updatedItinerary.originalPrice;
};

export default getItineraryPriceBeforeUpdate;
